import React from 'react';
import './App.css';
import Logo from './logo.png'
import Phone from './phoneDesign.png'
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from 'react-bootstrap/Button'
import 'bootstrap/dist/css/bootstrap.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons'

function App() {
  return (
    <div className="App">
      <header className="App-header">
          <img src={Logo} alt="" width="260px" height="60px" />     
      </header>

      <Container>
                  <Row className="">
                  <Col md={7} sm={7} xs={12}>
                
                        <h1 className="textHeader"> 
                        Get Quick Loans</h1>
                        <span className="tagLine"> Receive in Minutes</span>


<br/><br/>
                    <Row className="">
                      <Col md={1} sm={1} xs={3}>
                      <FontAwesomeIcon icon={faCheckCircle} className="checkIcon" />
                      </Col>
                      <Col md={10} sm={10} xs={10}> 
                            <p className="steps">
                            Get access to loans from N5,000 and N50,000                   
                            </p>
                      </Col>
                    </Row>


                    <Row className="">
                      <Col md={1} sm={1} xs={3}>
                      <FontAwesomeIcon icon={faCheckCircle} className="checkIcon" />
                      </Col>
                      <Col md={10} sm={10} xs={10}> 
                            <p className="steps">
                            Chat our representative via whatsapp and get confirmed. Click on the link below      
                            </p>
                      </Col>
                    </Row>


                    <Row className="">
                      <Col md={1} sm={1} xs={3}>
                      <FontAwesomeIcon icon={faCheckCircle} className="checkIcon" />
                      </Col>
                      <Col md={10} sm={10} xs={10}> 
                            <p className="steps">
                            Only Verified customers have access to N2,000,000                
                            </p>
                      </Col>
                    </Row>

<div className="text-center">
               <a href="https://api.whatsapp.com/send?phone=+2349025764665&amp;text=I%20will%20Like%20to%20apply%20for%20a%20loan.%20" target="blankß"> <Button className="actBtn" size="lg" active>
               Get Loan
                </Button></a>
                </div>
                    </Col>


                    <Col md={5} sm={5} xs={12} className="text-center">
                    <br/>  
                      <img src={Phone} alt="" width="55%" height="100%" />     
                     </Col>
                  </Row>

               
     </Container>



    </div>
  );
}

export default App;
